
$(document).ready(function(){


	$.ajaxSetup({
	    headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    }
	});

	$.featherlight.defaults.closeOnClick = false;
	$.featherlight.defaults.loading = '<i class="fas fa-cog fa-pulse text-primary"></i> Espere...';
	$.featherlight.defaults.otherClose = '.btn-close';


	// Bind .ajax class to Featherlight Popup
	$('a.ajax').click(function(e){

		var $link = $(this);
		var $href = $(this).attr('href');

		if($href.length > 1)
			$.featherlight($href, { type: 'ajax' });

		e.preventDefault();

	});



	$('.select_all').click(function(e) {
		e.preventDefault();
	    var checkboxes = $(this).closest('form').find(':checkbox');
	    checkboxes.prop('checked', true);
	});

	$('.select_none').click(function(e) {
		e.preventDefault();
	    var checkboxes = $(this).closest('form').find(':checkbox');
	    checkboxes.prop('checked', false);
	});

});



